import './TaskSummary.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { InitiativeSubSection } from '../general/InitiativeSubSection';
import { Progress } from 'antd';
import React from 'react';
import { SonarText } from '@ui/text';
import { useInitiativeTasks } from '@hooks';
import { CheckCircleOutlined, UnorderedListOutlined } from '@ant-design/icons';
export const InitiativeTasksSummary = ({ initiativeId }) => {
    var _a;
    const { tasks } = useInitiativeTasks(initiativeId);
    const taskCount = tasks.length;
    const completedTaskCount = (_a = tasks.filter((task) => task.completed).length) !== null && _a !== void 0 ? _a : 0;
    const taskProgress = Math.floor((completedTaskCount / taskCount) * 100);
    if (!taskCount) {
        return null;
    }
    const tasksCompletedText = `${completedTaskCount}/${taskCount} ${COPY_SPECIFIC.COMPLETE}`;
    return (React.createElement(React.Fragment, null,
        React.createElement(Progress, { className: 'initiative-task-progress-bar', percent: taskProgress }),
        React.createElement(InitiativeSubSection, { count: taskCount, direction: 'horizontal', icon: React.createElement(UnorderedListOutlined, null), id: 'initiative-task-summary', reducedPadding: true, title: COPY_SPECIFIC.TASKS },
            React.createElement("span", null,
                React.createElement(CheckCircleOutlined, null),
                React.createElement(SonarText, null, tasksCompletedText)))));
};
